import { TOrganizationInvitationItem, TOrganizationItem } from "@/data/types";

export interface OrganizationsState {
  items: TOrganizationItem[];
  currentOrganization: TOrganizationItem | null;
  invitations: TOrganizationInvitationItem[];
}

export const DefaultOrganizationsState: OrganizationsState = {
  items: [],
  currentOrganization: null,
  invitations: [],
};
